import ApiService from '@/helpers/api.service';

const API = new ApiService();

export const state = {
    erpUsersList: [],
    erpUsersListPageInfo: {
        total: 0
    },
    lineManagers: [],
    errors: null
}

export const mutations = {
    UPDATE_USERS_LIST(state, list){
        state.erpUsersList = list;
    },
    UPDATE_USERS_LIST_PAGE_INFO(state, total){
        state.erpUsersListPageInfo.total = total;
    },
    UPDATE_MANAGER_LIST(state, list){
        state.lineManagers = list;
    },
    SET_PROD_ERRORS(state, errors){
        state.errors = errors;
    }
}

export const actions = {
    getErpUsersList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/users/list`, params.body)
            .then(({ data }) => {
              context.commit('UPDATE_USERS_LIST', data.message.rows);
              context.commit('UPDATE_USERS_LIST_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    readUser(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/users/read`, params.body)
            .then(({ data }) => {
              context.commit('UPDATE_USERS_LIST', data.message.rows);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.data.errors);
              reject();
            });
        });
    },
    manageUser(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/users/${params.action}`, params.body)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    fetchLineManagers(context){
        return new Promise((resolve, reject) => {
            API.post(`/users/line-managers`)
            .then(({ data }) => {
                if(data.status === "ok") {
                    context.commit('UPDATE_MANAGER_LIST', data.message.rows);
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    actionERPUsers(context, params) {
      return new Promise((resolve, reject) => {
        API.post(`/users/${params.action}`, params.body)
          .then(({ data }) => {
            if (data.status === "ok") {
              resolve(data)
            } else {
              reject(data.message)
            }
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject();
          });
      });
    },
}